import { render } from "./QuizCarousel.vue?vue&type=template&id=4ec419cd&scoped=true"
import script from "./QuizCarousel.vue?vue&type=script&lang=js"
export * from "./QuizCarousel.vue?vue&type=script&lang=js"

import "./QuizCarousel.vue?vue&type=style&index=0&id=4ec419cd&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/eoy-2022-frontend/eoy-2022-frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec419cd"]])

export default __exports__